import { Component, Input } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'calosft-scroll-ultimation',
  templateUrl: './scroll-ultimation.component.html',
  styleUrls: ['./scroll-ultimation.component.scss']
})
export class ScrollUltimationComponent {
  @Input() item: any;

  @Input() img: any;

  @Input() data: any;
    public serverPath = environment.commonImageApi + '/home/';
  
    public serverPath1 = environment.commonImageApi + '/commonSlider/';
    public bannerServerPath = environment.commonImageApi + '/commonSlider/';;
  
  showHeading = false;
showDescription = false;

ngOnInit() {
  setTimeout(() => {
    this.showHeading = true;
    setTimeout(() => {
      this.showDescription = true;
    }, 600); // Delay for description after heading
  }, 100); // Slight delay before showing
}
  ngAfterViewInit() {
    gsap.registerPlugin(ScrollTrigger);
    this.initScrollAnimations();
  }

  private initScrollAnimations(): void {
    const scrollSections = document.querySelectorAll(".scroll-section");

    scrollSections.forEach((section: Element) => {
      const wrapper = section.querySelector(".wrapper");
      if (!wrapper) return;

      const items = wrapper.querySelectorAll(".item");
      let direction: 'vertical' | 'horizontal' | null = null;

      if (section.classList.contains("vertical-section")) {
        direction = "vertical";
      } else if (section.classList.contains("horizontal-section")) {
        direction = "horizontal";
      }

      if (direction) {
        this.initScroll(section as HTMLElement, Array.from(items) as HTMLElement[], direction);
      }
    });
  }

  private initScroll(section: HTMLElement, items: HTMLElement[], direction: 'vertical' | 'horizontal'): void {
    // Initial states
    items.forEach((item, index) => {
      if (index !== 0) {
        gsap.set(item, {
          [direction === "horizontal" ? "xPercent" : "yPercent"]: 100
        });
      }
    });

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        pin: true,
        start: "top top",
        end: () => `+=${items.length * 100}%`,
        scrub: 1,
        invalidateOnRefresh: true
        // markers: true, // Uncomment for debugging
      },
      defaults: { ease: "none" }
    });

    items.forEach((item, index) => {
      timeline.to(item, {
        scale: 0.9,
        borderRadius: "10px"
      });

      if (items[index + 1]) {
        timeline.to(
          items[index + 1],
          {
            [direction === "horizontal" ? "xPercent" : "yPercent"]: 0
          },
          "<"
        );
      }
    });
  }
}
